import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Back/IndexView.vue'
import MainView from '../views/Back/MainView.vue'
import AdminListView from '../views/Back/Admin/AdminListView.vue'
import PermissionListView from '../views/Back/Permission/PermissionListView.vue'
import RoleListView from '../views/Back/Role/RoleListView.vue'

import OrderListView from '../views/Back/Order/OrderListView.vue'
import ProductListView from '../views/Back/Product/ProductListView.vue'
import UserListView from '../views/Back/User/UserListView.vue'
import NotifyListView from '../views/Back/Notify/NotifyListView.vue'

import ArticleListView from '../views/Back/Article/ArticleListView.vue'
import BannerListView from '../views/Back/Banner/BannerListView.vue'
import ArticleFavouriteView from '../views/Back/Favourite/ArticleFavouriteView.vue'
import ProductFavouriteView from '../views/Back/Favourite/ProductFavouriteView.vue'
import VideoListView from '../views/Back/Video/VideoListView.vue'
import TypeListView from '../views/Back/Type/TypeListView.vue'

import CourseListView from '../views/Back/Course/CourseListView.vue'
import CourseRecordListView from '../views/Back/CourseRecord/CourseRecordListView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/Main',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/Admin/List',
        name: 'AdminListView',
        component: AdminListView
      },
      {
        path: '/Permission/List',
        name: 'PermissionListView',
        component: PermissionListView
      },
      {
        path: '/Role/List',
        name: 'RoleListView',
        component: RoleListView
      },
      {
        path: '/Order/List',
        name: 'OrderListView',
        component: OrderListView
      },
      {
        path: '/Product/List',
        name: 'ProductListView',
        component: ProductListView
      },
      {
        path: '/User/List',
        name: 'UserListView',
        component: UserListView
      },
      {
        path: '/Notify/List',
        name: 'NotifyListView',
        component: NotifyListView
      },
      {
        path: '/Article/List',
        name: 'ArticleListView',
        component: ArticleListView
      },
      {
        path: '/Banner/List',
        name: 'BannerListView',
        component: BannerListView
      },
      {
        path: '/Favourite/Article',
        name: 'ArticleFavouriteView',
        component: ArticleFavouriteView
      },
      {
        path: '/Favourite/Product',
        name: 'ProductFavouriteView',
        component: ProductFavouriteView
      },
      {
        path: '/Video/List',
        name: 'VideoListView',
        component: VideoListView
      },
      {
        path: '/Type/List',
        name: 'TypeListView',
        component: TypeListView
      },
      {
        path: '/Course/List',
        name: 'CourseListView',
        component: CourseListView
      },
      {
        path: '/CourseRecord/List',
        name: 'CourseRecordListView',
        component: CourseRecordListView
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
